
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Search, Download, Printer } from "lucide-react";
import { EtsyOrder } from "@/types/etsy";
import { printOrdersBulk } from "@/utils/bulkPrint";
import ExportDialog from "./ExportDialog";
import OrdersFilterDialog from "./OrdersFilterDialog";
import AddOrderDialog from "./AddOrderDialog";

interface OrdersFiltersProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  orders: EtsyOrder[];
  onFiltersChange: (filteredOrders: EtsyOrder[]) => void;
  onOrderAdd?: (newOrder: EtsyOrder) => void;
}

const OrdersFilters = ({ searchTerm, onSearchChange, orders, onFiltersChange, onOrderAdd }: OrdersFiltersProps) => {
  const handleBulkPrint = () => {
    printOrdersBulk(orders);
  };

  const handleOrderAdd = (newOrder: EtsyOrder) => {
    if (onOrderAdd) {
      onOrderAdd(newOrder);
    }
  };

  return (
    <div className="flex flex-col sm:flex-row gap-4 mt-4">
      <div className="relative flex-1">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" />
        <Input
          placeholder="Search orders..."
          className="pl-10"
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>
      <div className="flex gap-2">
        <OrdersFilterDialog orders={orders} onFiltersChange={onFiltersChange}>
          <Button variant="outline">
            <Search className="mr-2 h-4 w-4" />
            Filter
          </Button>
        </OrdersFilterDialog>
        <ExportDialog orders={orders}>
          <Button 
            variant="outline"
            disabled={orders.length === 0}
          >
            <Download className="mr-2 h-4 w-4" />
            Export to CSV
          </Button>
        </ExportDialog>
        <AddOrderDialog onOrderAdd={handleOrderAdd} />
        <Button 
          variant="outline" 
          className="bg-green-50 text-green-700 border-green-200 hover:bg-green-100 hover:text-green-800"
          onClick={handleBulkPrint}
          disabled={orders.length === 0}
        >
          <Printer className="mr-2 h-4 w-4" />
          Bulk Print
        </Button>
      </div>
    </div>
  );
};

export default OrdersFilters;
